function selectMt() {
    let $selectMt = document.querySelectorAll('.select-mt');
    let $selectMtSelect = 'select';
    let option, currentSelect, $copySelect, newSelect, selectName;
    let createOption = ''

    let template = function () {
        return `
            <div class="select-mt__checked">
                <div class="elect-mt__checked-name"></div>
                <div class="select-mt__arrow"></div>
            </div>
            <div class="select-mt__dropdown"></div>
            <div class="select-mt__result"></div>
        `;
    }

    $selectMt.forEach(select => {
        currentSelect = select
        $selectMtSelect = select.querySelector('select')
        selectName = currentSelect.getAttribute("data-name")
        // selectName = $selectMtSelect.options[$selectMtSelect.selectedIndex].innerText

        $copySelect = $selectMtSelect.cloneNode(true);
        option = select.querySelectorAll('option')
        createOptions(option)
        render(select);
    })

    function createOptions(optionData) {
        createOption = ''
        optionData.forEach((item, i) => {
            createOption += `
                <div class="select-mt__items" data-id="${i}">${item.innerText}</div>
            `;
        });
    }

    function dropDownEvent(select) {
        let dropDownInit = select.querySelector('.select-mt__dropdown')

        dropDownInit.addEventListener('click', (e) => {
            let $target = e.target
            let $clickItems = false;

            if ($target.classList.contains('select-mt__items')) {
                $clickItems = $target;
            } else if ($target.closest('.select-mt__items') !== null) {
                $clickItems = $target.closest('.select-mt__items');
            }
            selectedCheck($clickItems)
            dropdownWork($clickItems)
            dropDownHide($clickItems)
        })
    }

    const selectedCheck = (itemOption) => {
        let selectParent = itemOption.parentNode.parentNode;
        let indexOption = itemOption.getAttribute('data-id')
        let dropResultInit = selectParent.querySelector('.select-mt__result')


        selectParent.querySelector('select').options[indexOption].selected = true
        dropResultInit.innerHTML = selectParent.querySelector('select').options[indexOption].innerText
    }

    function render(select) {
        select.innerHTML = template()
        select.append($copySelect)
        select.querySelector('.elect-mt__checked-name').innerHTML = selectName
        select.querySelector('.select-mt__dropdown').innerHTML = createOption
        dropDownEvent(select);
    }

    function dropdownWork(item) {
        let selectParent = item.parentNode;
        let dropDownItems = selectParent.querySelectorAll('.select-mt__items')
        dropDownItems.forEach(item => {
            item.classList.remove('select-mt__items--active')
        })
        dropDownItems[item.getAttribute('data-id')].classList.add('select-mt__items--active')
    }

    function dropDownShow(item) {
        // let selectParent = item.parentNode
        let checkedDropDown = document.querySelectorAll('.select-mt__checked')
        checkedDropDown.forEach(item => {
            item.addEventListener('click', () => {
                if(!item.classList.contains('select-mt__checked--active')) {

                }
                item.classList.toggle('select-mt__checked--active')
                item.nextElementSibling.classList.toggle('select-mt__dropdown--active')

            })
        })


        // selectParent.classList.add('select-mt__dropdown--active')
    }
    dropDownShow()

    function dropDownHide(item) {
        let selectParent = item.parentNode
        selectParent.previousElementSibling.classList.toggle('select-mt__checked--active')
        selectParent.classList.toggle('select-mt__dropdown--active')
    }



}

selectMt()